export const selectFilters = (page) => (state) =>
  state.finDataRequest.filters[page];

export const selectCustomerId = (state) => state.customer.customer.id;
export const selectCustomerRole = (state) => state.customer.customer.customerRole;

export const selectClientId = (state) => state.client.client.id;

export const selectUserId = (state) => state.user.user.id;
